import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RealEstatesLegacyComponent, RealEstateTableEntity } from '../real-estates-legacy.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'ara-real-estates-select-dialog',
	imports: [MatDialogModule, MatButtonModule, RealEstatesLegacyComponent, TranslocoDirective, CdkDrag, CdkDragHandle, MatIcon],
	templateUrl: './real-estates-select-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./real-estates-select-dialog.component.scss'],
})
export class RealEstatesSelectDialogComponent {
	protected dialogRef = inject(MatDialogRef<RealEstatesSelectDialogComponent>);
	private readonly data = inject(MAT_DIALOG_DATA);

	onRealEstateSelected(realEstate: RealEstateTableEntity): void {
		this.dialogRef.close(realEstate);
	}
}
